import { PlatformAppShell, type NavSection } from '@codezo/ui';
import {
	IconBarbell,
	IconDashboard,
	IconUsers,
	IconCategory,
	IconHeart,
	IconLanguage,
	IconMail,
} from '@tabler/icons-react';
import { Outlet, useNavigate } from 'react-router-dom';
import { HeaderNavigation } from '../components/HeaderNavigation';
import { Logo } from '../components/Logo';

export function PlatformLayout() {
	const navigate = useNavigate();

	const navigationSections: NavSection[] = [
		{
			title: 'Overview',
			items: [
				{
					label: 'Dashboard',
					path: '/dashboard',
					icon: <IconDashboard size={18} />,
				},
				{
					label: 'Workouts',
					path: '/workouts',
					icon: <IconBarbell size={18} />,
				},
				{
					label: 'Categories',
					path: '/categories',
					icon: <IconCategory size={18} />,
				},
				{
					label: 'Well-being Survey',
					path: '/wellbeing',
					icon: <IconHeart size={18} />,
				},
				{
					label: 'Translations',
					path: '/translations',
					icon: <IconLanguage size={18} />,
				},
			],
		},
		{
			title: 'Administration',
			items: [
				{
					label: 'Admin Users',
					path: '/users',
					icon: <IconUsers size={18} />,
				},
				{
					label: 'Regular Users',
					path: '/regular-users',
					icon: <IconUsers size={18} />,
				},
				{
					label: 'Newsletter',
					path: '/newsletter',
					icon: <IconMail size={18} />,
				},
			],
		},
	];

	return (
		<PlatformAppShell
			navigation={navigationSections}
			logo={<Logo onClick={() => navigate('/dashboard')} height={28} />}
			headerRight={<HeaderNavigation />}
		>
			<Outlet />
		</PlatformAppShell>
	);
}
